import React$1 from 'react';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import StyledText from './Text.style.js';

const highlightedPart = /\*\*(.*?)\*\*/g;

const Text = (_ref) => {
  let {
    content,
    hasGrid,
    hasOuterMargins,
    className,
    hasAccent
  } = _ref,
      props = _objectWithoutProperties(_ref, ["content", "hasGrid", "hasOuterMargins", "className", "hasAccent"]);

  if (!content) return null; // Add link icons to text

  const splittedContent = content.split('</a>');
  const updatedText = splittedContent.map((item, i) => i + 1 === splittedContent.length ? item : `${item}<span class="text__link-icon-wrapper">&nbsp;<span class="text__link-icon"></span></span></a>`);
  const text = updatedText.join('').replace(highlightedPart, '<span class="text__highlight">$1</span>');
  return /*#__PURE__*/React$1.createElement(StyledText, _extends({
    content: text,
    className: className,
    hasGrid: hasGrid,
    hasAccent: hasAccent,
    hasOuterMargins: hasOuterMargins
  }, props));
};

Text.propTypes = {
  className: PropTypes$1.string,
  content: PropTypes$1.string,
  hasGrid: PropTypes$1.bool,
  hasAccent: PropTypes$1.bool,
  hasOuterMargins: PropTypes$1.bool
};
Text.defaultProps = {
  className: '',
  content: '',
  hasGrid: false,
  hasAccent: false,
  hasOuterMargins: false
};

export default Text;
